import React from 'react';
import { Input, Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import type { AgentChatPanel } from '../../hooks/useAgentChatPanel';
import AgentMessageList from './AgentMessageList';
import ChatEmptyState from './ChatEmptyState';
import styles from './AgentChatColumn.module.css';

interface AgentChatColumnProps {
  panel: AgentChatPanel;
}

// Message area (empty-state or virtualized list) + composer. The chat content
// is capped to a fixed, readable width and centered so it never stretches; in
// the narrow drawer the container is already below the cap, so it's a no-op.
const AgentChatColumn: React.FC<AgentChatColumnProps> = ({ panel }) => {
  const showEmptyState = (panel.items?.length ?? 0) === 0 && !panel.streaming;

  return (
    <div className={styles.column}>
      <div className={styles.messages}>
        {showEmptyState ? (
          <div className={styles.centered}>
            <ChatEmptyState pageContext={panel.pageContext} onPick={panel.sendText} />
          </div>
        ) : (
          <AgentMessageList
            items={panel.items}
            onConfirm={panel.confirmProposal}
            onAllowAlways={panel.allowAlways}
          />
        )}
      </div>

      <div className={styles.composerWrap}>
        <div className={styles.composer}>
          <Input.TextArea
            placeholder="Запитайте асистента…"
            value={panel.draft}
            onChange={(e) => panel.setDraft(e.target.value)}
            autoSize={{ minRows: 1, maxRows: 4 }}
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault();
                panel.handleSend();
              }
            }}
          />
          <Button
            type="primary"
            icon={<SendOutlined />}
            loading={panel.streaming}
            onClick={panel.handleSend}
          >
            Надіслати
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgentChatColumn;
